import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { TrustStrip } from '../components/TrustStrip';
import { ProblemSection } from '../components/ProblemSection';
import { RolePaths } from '../components/RolePaths';
import { WorkflowSection } from '../components/WorkflowSection';
import { ProductPillars } from '../components/ProductPillars';
import { AISection } from '../components/AISection';
import { ComparisonSection } from '../components/ComparisonSection';
import { PricingTeaser } from '../components/PricingTeaser';
import { FAQ } from '../components/FAQ';
import { FinalCTA } from '../components/FinalCTA';
export function HomePage() {
  return <>
      <HeroSection data-id="element-6499" />
      <TrustStrip data-id="element-6500" />
      <ProblemSection data-id="element-6501" />
      <RolePaths data-id="element-6502" />
      <WorkflowSection data-id="element-6503" />
      <ProductPillars data-id="element-6504" />
      <AISection data-id="element-6505" />
      <ComparisonSection data-id="element-6506" />
      <PricingTeaser data-id="element-6507" />
      <FAQ data-id="element-6508" />
      <FinalCTA data-id="element-6509" />
    </>;
}